module.exports = __webpack_public_path__ + "static/media/newsletter-august-2021-joe-laychak.a854a1fa.jpg";